var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input-text',_vm._g(_vm._b({directives:[{name:"mask",rawName:"v-mask",value:([
    '#####.##### #####.###### #####.###### # ##############',
    '############ ############ ############ ############',
  ]),expression:"[\n    '#####.##### #####.###### #####.###### # ##############',\n    '############ ############ ############ ############',\n  ]"}],attrs:{"required":_vm.required,"disabled":_vm.disabled,"placeholder":_vm.placeholder},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'input-text',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }